import {ListDecorator} from './base/ListDecorator';
import {Store} from '@ngrx/store';
import {IAppStore} from '@app/store';
import {POImage} from '../model/POImage';
import {of} from 'rxjs';
import {translate} from '@ngneat/transloco';

export class PODocScanListDecorator extends ListDecorator {
  isDelBtn$ = of(true);
  isEditBtn$ = of(true);
  isAddBtn$ = of(true);

  constructor(public store: Store<IAppStore>) {
    super(POImage.type);

    const {tPrefix} = this;
    const mainTPrefix = `${tPrefix}doc-scan.`;
    this.title = `${mainTPrefix}title`;
    const translationFields = [
      'delTitle',
      'oneItemTitle',
      'oneItemNewTitle',
      'oneItemNotFound',
    ];
    this.translateTitleFields(mainTPrefix, translationFields);
    this.headerCaptions$ = of({
      id: translate('ID'),
      label: translate(`${mainTPrefix}label`),
    });
    const headers = ['id', 'label'];
    this.headers$ = of(headers);
    this.sortIDs = {
      id: true,
      label: true,
    };
  }
}
